import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import "./styles/theme.css";
import "./styles.css";
import "./styles/shell.css";
import "./styles/desktop.css";
import "./styles/terminal.css";
import "./styles/home.css";
import "./styles/notebook.css";
import "./styles/mission-control.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
